import { Box, Chip, Dialog, DialogActions, DialogContent, Stack, Typography } from '@mui/material';
import React, { useEffect } from 'react'
import { CustomDialogTitle } from '../../../../Common/Custom/CustomDialogTitle';
import { VerificationWorkflowService } from '../../../../../Component/Api/VerificationAgency/VerificationWorkflow/VerificationWorkflowService';
import { ImportManagement } from '../../../../../Component/Model/Dto/VerificationAgency/Client/ImportManagement/ImportManagement';
import { SmallLoading } from '../../../../../Component/Common/Components/Loading/IntermediateLoading';

import colors from '../../../../../assets/theme/base/colors';

const { primary, success, error } = colors;

interface IProps {
    id: number;
    showModal: boolean;
    closeModal: () => void;
}

export const FileManagementImportModal = (props: IProps) => {
    const [importSheets, setImportSheets] = React.useState<ImportManagement.ImportDetailSheetDto[]>([]);
    const [isLoading, setIsLoading] = React.useState(false);

    const fetchData = async () => {
        setIsLoading(true);
        try {
            const response = await VerificationWorkflowService.GetImportDetails(props.id);
            setImportSheets(response.data.progressSheets ?? []);
        } catch (error) {
            console.log(error)
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        if (props.id > 0) {
            fetchData();
        }
    }, [props.id]);

    const Circle: React.FC<{ color: string }> = ({ color }) => {
        return (
            <div
                style={{
                    width: '15px',
                    height: '15px',
                    borderRadius: '50%',
                    background: color,
                    marginRight: '8px',
                }}
            />
        );
    };

    const Legend = () => {
        return (
            <Box width="100%" mt={2}>
                <Stack direction="row" spacing={2}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <Circle color={success.main} />
                        <Typography variant="caption">
                            Completed
                        </Typography>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <Circle color={error.main} />
                        <Typography variant="caption">
                            Failed
                        </Typography>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <Circle color={primary.main} />
                        <Typography variant="caption">
                            In Progress
                        </Typography>
                    </div>
                </Stack>
            </Box>
        )
    }

    const renderChips = () => {
        const chipStyle = { color: 'white' };
        return (
            <>
                <Box
                    width="100%"
                    sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 1
                    }}
                >
                    {importSheets.map((sheet, index) => (
                        <Chip
                            key={index}
                            label={sheet.dataPageName}
                            color={
                                sheet.status === 0 ? "primary" :
                                    sheet.status === 1 ? "success" :
                                        sheet.status === 2 ? "error" :
                                            undefined
                            }
                            style={chipStyle}
                        />
                    ))}
                </Box>
                <Legend />
            </>
        );
    }


    return (
        <Dialog disableEnforceFocus open={props.showModal} onClose={props.closeModal} aria-labelledby="form-dialog-title" maxWidth='lg'>
            <CustomDialogTitle id="customized-dialog-title" onClose={props.closeModal}>
                Data Sheets Selected
            </CustomDialogTitle>
            <DialogContent sx={{ width: '650px' }}>
                {isLoading && <SmallLoading />}
                {!isLoading && renderChips()}
            </DialogContent>

        </Dialog>
    )
}
